import { RoutesPaths } from "../../../constants/routes.ts"
import type { RecordRef } from "../types/messages.types.ts"

export const recordLink = (record: RecordRef | null | undefined) => {
  if (!record) return null
  switch (record.type) {
    case "lead":
      return RoutesPaths.lead.view(record.id)
    case "project":
      return RoutesPaths.project.view(record.id).overview
    case "customer":
      return RoutesPaths.customers.view(record.id)
    case "subcontractor":
      return RoutesPaths.subcontractors.view(record.id)
    case "supplier":
      return RoutesPaths.suppliers.view(record.id)
    default:
      return null
  }
}

export const recordLabel = (record: RecordRef) =>
  record.label || record.name || ""
